import * as React from "react";
import { FieldNav } from "../components/FieldNav.js";
import { FieldFooter } from "../components/FieldFooter.js";
import { MailtoContact } from "../components/MailtoContact.js";
import { useDocumentTitle } from "../hooks/useDocumentTitle.js";
import { SEO_TITLES } from "../lib/seo-titles.js";
import "../styles/landing-field.css";
import "../styles/content-pages-field.css";

// Confirm before relying on these: legal entity / operator name, and that the
// team@ inbox is monitored.
export function PrivacyRoute(): React.ReactElement {
  useDocumentTitle(SEO_TITLES["/privacy"]);
  return (
    <div className="v-field">
      <FieldNav />
      <main id="main" className="v-field-c__page">
        <div className="container">
          <span className="v-field-c__eyebrow">Legal</span>
          <h1 className="v-field-c__title">Privacy Policy</h1>
          <p className="v-field-c__updated">Effective June 6, 2026</p>
          <p className="v-field-c__lede">
            We keep this short: we collect the least we need to run the games, and we never sell
            student data.
          </p>
          <div className="v-field-c__prose">
            <h2>The short version</h2>
            <ul>
              <li>No ads or tracking ever run inside the games.</li>
              <li>We never sell student data or use it to advertise to students.</li>
              <li>Parents and schools can review or delete a student's data anytime.</li>
            </ul>

            <h2>What we collect</h2>
            <p>
              To run the games and remember progress, we store gameplay results (scores, accuracy,
              topics played) and a small cookie on your device. If you sign in, we store your email;
              if you subscribe, our payment processor handles your card details. Our public pages
              also use standard analytics and advertising cookies — the games stay separate and
              tracker-free.
            </p>

            <h2>Children, schools, and your choices</h2>
            <p>
              Children under 13 use Sports Academy Games with consent from a parent, guardian, or
              school. To review, correct, or delete information — or close an account — email{" "}
              <MailtoContact />. We'll update this page if anything changes.
            </p>

            <h2>Text Messaging Data</h2>
            <p>
              Text messaging originator opt-in data and consent will not be shared with any third
              parties, excluding aggregators and providers of the Text Message services.
            </p>
          </div>
        </div>
      </main>
      <FieldFooter />
    </div>
  );
}
